// global url consts

const BASE_YT_EMBED_URL = "https://www.youtube-nocookie.com/embed/";
const GNC_URL = "https://www.cefonline.com/ministries/goodnewsclub/";
const PFM_URL = "https://www.prayformecampaign.com/";
const UPWARD_URL = "https://www.upward.org/";
const ESV_URL = "https://www.esv.org/";
const FB_URL = "https://www.facebook.com/groups/FirstBaptistEclectic";
const IG_URL = "https://www.instagram.com/fbcglorybound/";
const YT_URL = "https://www.youtube.com/channel/UCqOE4fLVedJ2vu_M9Yn_y3w";
const PHONE_URL = "tel:+13345414444";
const EMAIL_URL = "mailto:fbceministry@gmail.com";
const POD_URL = "https://podcasts.apple.com/us/podcast/churchtalks/id1729284644";
const PODCAST_RSS_URL = "https://anchor.fm/s/f1be601c/podcast/rss";
const SERMON_RSS_URL = "https://anchor.fm/s/f26b0ccc/podcast/rss";

const YT_THUMB_URL = (id) => `http://img.youtube.com/vi/${id}/1.jpg`;

export {
  BASE_YT_EMBED_URL,
  GNC_URL,
  PFM_URL,
  UPWARD_URL,
  ESV_URL,
  FB_URL,
  IG_URL,
  YT_URL,
  PHONE_URL,
  EMAIL_URL,
  POD_URL,
  PODCAST_RSS_URL,
  SERMON_RSS_URL,
  YT_THUMB_URL,
};
